import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';
import closeIcon from '../../../../images/icons/close.svg';
import crueltyFreeIcon from '../../../../images/value_tags/cruelty_free.svg';
import cleanIcon from '../../../../images/value_tags/clean.svg';
import glutenFreeIcon from '../../../../images/value_tags/gluten_free.svg';
import sulfateFreeIcon from '../../../../images/value_tags/sulfate_free.svg';
import veganIcon from '../../../../images/value_tags/vegan.svg';
import nanoparticleFreeIcon from '../../../../images/value_tags/nanoparticle_free.svg';
import reefSafeIcon from '../../../../images/value_tags/reef_safe.svg';
import siliconeFreeIcon from '../../../../images/value_tags/silicone_free.svg';

import './IngredientsList.sass';

const VALUE_TAGS_IMAGES = {
  cruelty_free: crueltyFreeIcon,
  clean: cleanIcon,
  gluten_free: glutenFreeIcon,
  vegan: veganIcon,
  sulfate_free: sulfateFreeIcon,
  nanoparticle_free: nanoparticleFreeIcon,
  reef_safe: reefSafeIcon,
  silicone_free: siliconeFreeIcon,
};

function IngredientsList(props) {
  const {
    text, detailedIngredients, detailedIngredientsHeading, valueTags = [],
  } = props;

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const toggleModal = () => {
    setModalIsOpen((prevModalIsOpen) => !prevModalIsOpen);
  };

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: text }} />
      { detailedIngredients && (
        <>
          <ClickableDiv className="full-list-link" onClick={toggleModal}>
            {detailedIngredientsHeading}
          </ClickableDiv>
          <Modal isOpen={modalIsOpen} className="ingredients-modal" ariaHideApp={false}>
            <div className="content">
              <button className="close-modal" type="button" onClick={toggleModal}>
                <img alt="close modal" src={closeIcon} width="24" height="24" />
              </button>
              <div className="body">
                <div className="text" dangerouslySetInnerHTML={{ __html: detailedIngredients }} />
              </div>
              <div className="value-tags">
                {valueTags.map((tag) => (
                  <div className="value-tag" key={tag}>
                    <img src={VALUE_TAGS_IMAGES[tag]} alt={tag.split('_').join(' ')} />
                    <div className="name">
                      {tag.split('_').join(' ')}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Modal>
        </>
      )}
    </>
  );
}

IngredientsList.propTypes = {
  text: PropTypes.string.isRequired,
  detailedIngredients: PropTypes.string,
  valueTags: PropTypes.arrayOf(PropTypes.string),
};

export default IngredientsList;
